import React, { useEffect, useState, useContext } from "react";
import blogFetch from "../../../axios/config";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { IBlock } from "./BlocInterfaces";
import RegisterBloc from "./RegisterBloc";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Modal } from "react-bootstrap";
import { getIdCompany } from "../../../utils/constantes";
import ButtonCustom from "../../../components/buttons/ButtonCustom";
import ButtonSaveCustom from "../../../components/buttons/SaveButton";
import Context from "../../../context/Context";
import language from "../../../nls/language.json";

export default function Bloc() {
  const [blocs, setBlocs] = useState<IBlock[]>();
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [blocId, setBlocId] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  const ref = React.useRef<any>(null);
  const styleCell = {
    padding: 1.5,
  };
  useEffect(() => {
    getBlocs();
  }, []);

  const getBlocs = async () => {
    try {
      let response = await blogFetch.get(`/bloc?companyid=${getIdCompany()}`);
      let data = response.data;
      setBlocs(data);
    } catch (error) {
      console.error(error);
    }
  };

  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterBloc ref={ref}></RegisterBloc>
        </Modal.Body>
        <Modal.Footer>
          <ButtonCustom
            typeButton="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalAdd(false)}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.modal.adicionar.btnCancelar}
          </ButtonCustom>
          <ButtonSaveCustom
            loading={loading}
            typeButton="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.addBloc();
                await getBlocs();
                setTimeout(() => {
                  setLoading(false);
                  setShowModalAdd(false);
                }, 500);
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.modal.adicionar.btnSalvar}
          </ButtonSaveCustom>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalEdit = () => {
    return (
      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.modal.editar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterBloc ref={ref} idBloc={blocId}></RegisterBloc>
        </Modal.Body>
        <Modal.Footer>
          <ButtonCustom
            typeButton="text"
            onClick={() => setShowModalEdit(false)}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.modal.editar.btnCancelar}
          </ButtonCustom>
          <ButtonSaveCustom
            loading={loading}
            typeButton="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.updateBloc();
                await getBlocs();
                setTimeout(() => {
                  setLoading(false);
                  setShowModalEdit(false);
                }, 500);
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.modal.editar.btnSalvar}
          </ButtonSaveCustom>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.title}
            </h3>
          </div>
          <div>
            <ButtonCustom
              typeButton="contained"
              onClick={() => setShowModalAdd(true)}
            >
              {(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.btnAdicionar}
            </ButtonCustom>
          </div>
        </div>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow className="table-header">
              <TableCell>#</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.tableHeader.descricao}</TableCell>
              <TableCell align="right">{(language as Record<string, any>)[selectedCountry.name].Cadastro.bloco.tableHeader.editar}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!!blocs &&
              blocs.map((item, index) => (
                <TableRow
                  key={item.blC_PK_idBLoc}
                  onMouseEnter={() =>
                    setHoveredRow(
                      item.blC_PK_idBLoc === undefined
                        ? null
                        : item.blC_PK_idBLoc
                    )
                  }
                  onMouseLeave={() => setHoveredRow(null)}
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      hoveredRow === item.blC_PK_idBLoc
                        ? "#F5F5F5"
                        : "transparent",
                  }}
                >
                  <TableCell sx={styleCell}>{item.blC_PK_idBLoc}</TableCell>
                  <TableCell sx={styleCell}>{item.blC_description}</TableCell>
                  <TableCell sx={styleCell} align="right">
                    <ModeEditIcon
                      onClick={() => {
                        setBlocId(item.blC_PK_idBLoc);
                        setShowModalEdit(true);
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      {modalAdd()}
      {modalEdit()}
    </>
  );
}
